/**
 * 图片面板拖入画布：按指针位置计算默认尺寸包围盒与落页/落工作区。
 */
import type { Page } from '@/components/canvas/document/publicTypes';
import { screenToWorld } from '@/components/canvas/document/coordinates';
import {
  findPageFullyContainingBounds,
  pageSurfaceWorldRect,
  type BoundsRect,
} from './elementOwnership';
import type { TextInsertVia } from './elementInsertTarget';

export const DEFAULT_MEDIA_IMAGE_DROP_SIZE = 200;

export function mediaImageWorldBoundsAtPointer(
  clientX: number,
  clientY: number,
  hostRect: DOMRect,
  panX: number,
  panY: number,
  zoom: number,
  size = DEFAULT_MEDIA_IMAGE_DROP_SIZE,
): BoundsRect {
  const center = screenToWorld(clientX, clientY, hostRect, panX, panY, zoom);
  const half = size / 2;
  return {
    x: center.x - half,
    y: center.y - half,
    width: size,
    height: size,
  };
}

export interface MediaImageDropResolution {
  via: TextInsertVia;
  pageId?: string;
  x: number;
  y: number;
  /** 完全落在页内时用于高亮该页；工作区落点时为 null */
  highlightPageId: string | null;
}

export function resolveMediaImageDrop(
  pages: Page[],
  worldBounds: BoundsRect,
): MediaImageDropResolution {
  const page = findPageFullyContainingBounds(pages, worldBounds);
  if (page) {
    const { x: ox, y: oy } = page.workspaceLayout;
    return {
      via: 'page',
      pageId: page.id,
      x: Math.round(worldBounds.x - ox),
      y: Math.round(worldBounds.y - oy),
      highlightPageId: page.id,
    };
  }
  return {
    via: 'workspace',
    x: Math.round(worldBounds.x),
    y: Math.round(worldBounds.y),
    highlightPageId: null,
  };
}
